module.exports = __webpack_public_path__ + "media/tile-5-image.7f08b92c.png";